import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { SessionStorageService, SessionTimeoutService } from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {
  private _timeoutExpired: boolean = false;

  constructor(
    private router: Router,
    private sessionState: SessionStorageService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    sessionTimeoutService.sessionTimedOut.subscribe((): void => {
      this._timeoutExpired = true;
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const tokenMissing: boolean = !this.sessionState.getAuthToken();
    const timeoutExpired: boolean = this._timeoutExpired;
    const redirectToLogin: boolean = tokenMissing || timeoutExpired;
    if (redirectToLogin) {
      // reset the flag so that the next time the user logs in, they will not be redirected to the login page again
      if (timeoutExpired) {
        this._timeoutExpired = false;
      }
      this.sessionState.clearAll();
      this.router.navigate(['/login']);
      this.sessionTimeoutService.stopTimer();
    }
    return !redirectToLogin;
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts